import {engineContext} from './context.js';

(function(g){'use strict';
const VERSION='0.1.0-alpha';
function need(){const x=g.ZooInvestResearchStatePersistenceAdapter;if(!x)throw Error('BASE_PERSISTENCE_ADAPTER_REQUIRED');return x;}
function rev(v){const n=Number(v);return Number.isInteger(n)&&n>=0?n:0;}
function pack(input={}){
  const base=need().pack(input);
  return Object.freeze({...base,revision:rev(input.revision)});
}
function migrate(record){
  const base=need().migrate(record);
  if(!base.migrated)return base;
  return Object.freeze({...base,record:Object.freeze({...base.record,revision:rev(base.record.revision)})});
}
function validateRecord(record){
  const base=need().validateRecord(record);
  const issues=[...(base.issues||[])];
  if(!Number.isInteger(Number(record?.revision))||Number(record?.revision)<0)issues.push('INVALID_REVISION');
  return Object.freeze({valid:issues.length===0,issues:Object.freeze(issues)});
}
function storageKey(symbol,scope){return need().storageKey(symbol,scope);}
function diff(a,b){
  const base=need().diff(a,b);
  const changed=[...(base.changed||[])];
  if(rev(a?.revision)!==rev(b?.revision))changed.push('revision');
  return Object.freeze({...base,changed:Object.freeze(changed),revisionChanged:changed.includes('revision')});
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  const p=pack({symbol:'AAA',scope:'OWNED',savedAt:'T',revision:4});
  ok('pack retains revision',p.revision===4);
  ok('pack validates',validateRecord(p).valid===true);
  ok('invalid revision rejected',validateRecord({...p,revision:-1}).valid===false);
  const m=migrate({...p,revision:undefined});
  ok('missing legacy revision becomes zero',m.record.revision===0);
  ok('diff detects revision',diff(p,{...p,revision:5}).revisionChanged===true);
  ok('storage key preserved',storageKey('aaa','owned').includes('OWNED:AAA'));
  ok('no trade signal',!('tradeSignal'in p));
  ok('no capital permission',!('capitalPermission'in p));
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
g.ZooInvestRevisionAwarePersistenceAdapter=Object.freeze({VERSION,pack,migrate,validateRecord,storageKey,diff,selfTest});
})(engineContext);